export class ContextFlow {
  private store: Map<string, unknown> = new Map();

  set<T>(key: string, value: T): void {
    this.store.set(key, value);
  }

  get<T>(key: string): T | undefined {
    const value = this.store.get(key);
    return (value as T) ?? undefined;
  }

  contains(key: string): boolean {
    return this.store.has(key);
  }

  remove(key: string): void {
    this.store.delete(key);
  }
}